import { Card } from "antd";

export const AppContentLayout = ({ title = false, cardChildren = false, children = false }) => {
    return (
        <div className="h-full">
            {title && <> {title} </>}
            {cardChildren &&
                <div className="bg-gray-50 px-4 py-6 h-full">
                    <Card classNames={{ body: 'bg-white rounded-lg shadow-sm border border-gray-100 p-4' }}>
                        {cardChildren}
                    </Card>
                </div>
            }
            {children && <>
                {children}
            </>}
        </div>
    )
}


export function PageSection({ screenName = false, screenDescription = false }) {
    if (screenName)
        return (
            <>
                <div className="bg-white border-b">
                    <div className="max-w-7xl mx-auto px-4 lg:px-6 py-4">
                        <div className="flex justify-between items-center">
                            <div>
                                <h1 className="text-xl font-semibold text-gray-900">{screenName}</h1>
                                <p className="mt-1 text-xs text-gray-500">{screenDescription}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    return <></>;
}